import { menuItemsDef, settingsItemsDef } from "../navigation/navDefinitions";

const ALL_NAV = [...menuItemsDef, ...settingsItemsDef]
  .filter((x) => x.link)
  .sort((a, b) => b.link.length - a.link.length);

/**
 * Título amigável para a rota atual na telemetria de presença.
 * @param {string} fullPath pathname + opcional ?query
 * @param {(key: string) => string} tNav — ex.: useTranslation("app").t
 */
export function getTeamPresenceScreenTitle(fullPath, tNav) {
  const path = String(fullPath || "").split("?")[0] || "";
  if (!path) return "—";
  for (const item of ALL_NAV) {
    const link = item.link;
    if (path === link || path.startsWith(`${link}/`)) {
      if (item.textKey) {
        const tr = tNav(item.textKey);
        if (tr && tr !== item.textKey) return tr;
      }
      if (item.label) return item.label;
      if (item.textKey) return tNav(item.textKey);
    }
  }
  return path;
}
